export const messages = {
  en: {
    activitiesManage: {
      search: {
        title: 'Search Conditions',
        activitiesId: 'Please enter activity ID',
        titlePlaceholder: 'Please enter title',
        typeCd: 'Please select activity type',
        staffName: 'Please enter publisher name'
      },
      list: {
        title: 'Activity List'
      },
      table: {
        activitiesId: 'Activity ID',
        title: 'Title',
        typeCd: 'Type',
        startTime: 'Start Time',
        endTime: 'End Time',
        userName: 'Publisher'
      },
      add: {
        title: 'Add Activity',
        titlePlaceholder: 'Required, please enter title',
        typeCd: 'Activity Type',
        startTime: 'start time',
        endTime: 'end time',
        typeCdPlaceholder: 'Required, please select type',
        isMoreCommunity: 'Multi-community',
        isMoreCommunityPlaceholder: 'Please select if multi-community',
        headerImg: 'Header Image (800*595)',
        startTimePlaceholder: 'Required, please enter start time',
        endTimePlaceholder: 'Required, please enter end time',
        context: 'Content'
      },
      edit: {
        title: 'Edit Activity',
        titlePlaceholder: 'Required, please enter title',
        typeCd: 'Activity Type',
        startTime: 'start time',
        endTime: 'end time',
        typeCdPlaceholder: 'Required, please select type',
        headerImg: 'Header Image (800*595)',
        startTimePlaceholder: 'Required, please enter start time',
        endTimePlaceholder: 'Required, please enter end time',
        context: 'Content'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete this activity?'
      },
      validate: {
        titleRequired: 'Title is required',
        titleMaxLength: 'Title cannot exceed 200 characters',
        typeCdRequired: 'Type is required',
        headerImgRequired: 'Header image is required',
        contextRequired: 'Content is required',
        startTimeRequired: 'Start time is required',
        endTimeRequired: 'End time is required',
        activitiesIdRequired: 'Activity ID is required',
        imageSize: 'Image size cannot exceed 2MB'
      }
    }
  },
  zh: {
    activitiesManage: {
      search: {
        title: '查询条件',
        activitiesId: '请输入活动ID',
        titlePlaceholder: '请输入标题',
        typeCd: '请选择活动类型',
        staffName: '请输入发布人名称'
      },
      list: {
        title: '活动列表'
      },
      table: {
        activitiesId: '活动ID',
        title: '标题',
        typeCd: '类型',
        startTime: '开始时间',
        endTime: '结束时间',
        userName: '发布人'
      },
      add: {
        title: '添加活动',
        titlePlaceholder: '必填，请输入标题',
        typeCd: '类型',
        startTime: '开始时间',
        endTime: '结束时间',
        typeCdPlaceholder: '必填，请选择类型',
        isMoreCommunity: '多园区',
        isMoreCommunityPlaceholder: '请选择是否多园区',
        headerImg: '头部照片(800*595)',
        startTimePlaceholder: '必填，请输入开始时间',
        endTimePlaceholder: '必填，请输入结束时间',
        context: '内容'
      },
      edit: {
        title: '编辑活动',
        titlePlaceholder: '必填，请输入标题',
        typeCd: '类型',
        typeCdPlaceholder: '必填，请选择类型',
        headerImg: '头部照片(800*595)',
        startTimePlaceholder: '必填，请输入开始时间',
        endTimePlaceholder: '必填，请输入结束时间',
        startTime: '开始时间',
        endTime: '结束时间',
        context: '内容'
      },
      delete: {
        title: '确认操作',
        confirmText: '确认删除该活动吗？'
      },
      validate: {
        titleRequired: '标题不能为空',
        titleMaxLength: '标题不能超过200个字符',
        typeCdRequired: '类型不能为空',
        headerImgRequired: '头部照片不能为空',
        contextRequired: '内容不能为空',
        startTimeRequired: '开始时间不能为空',
        endTimeRequired: '结束时间不能为空',
        activitiesIdRequired: '活动ID不能为空',
        imageSize: '图片大小不能超过2MB'
      }
    }
  }
}